<template>
    <div>
        <div class="panel-header panel-header-custom bg-primary-gradient">
            <div class="page-inner py-5">
                <div class="d-flex align-items-left align-items-md-center flex-column flex-md-row">
                    <div>
                        <h2 class="text-white pb-2 fw-bold">{{ $t("Настройка формулы СКБ") }}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-inner mt--5">
            <v-fade-transition mode="out-in">
                <div v-if="isLoading" key="acs-loader" aria-busy="true" aria-live="polite">
                    <v-row>
                        <v-col cols="12" md="3">
                            <v-card elevation="2">
                                <v-skeleton-loader
                                    type="heading"
                                    class="places-skeleton-loader acs-skeleton-heading"
                                ></v-skeleton-loader>
                                <v-card-text class="pt-0">
                                    <v-skeleton-loader
                                        v-for="n in 4"
                                        :key="'acs-filter-' + n"
                                        type="list-item-two-line, list-item, list-item, divider"
                                        class="places-skeleton-loader"
                                    ></v-skeleton-loader>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="9">
                            <v-card elevation="1" class="places-skeleton-card">
                                <v-skeleton-loader
                                    type="table-heading"
                                    class="places-skeleton-loader"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    v-for="n in 6"
                                    :key="'acs-skeleton-' + n"
                                    type="table-row-divider"
                                    class="places-skeleton-loader"
                                ></v-skeleton-loader>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
                <v-row v-else key="acs-content">
                <v-col cols="12" md="3">
                    <v-card elevation="2">
                        <v-card-title class="card-title-custom">{{ $t('Фильтры') }}</v-card-title>
                        <v-card-text>
                            <v-radio-group v-model="filterPaymentType" @change="onFilterChange">
                                <template v-slot:label>
                                    <div>{{ $t('Форма оплаты') }}</div>
                                </template>
                                <v-radio
                                    v-for="item in paymentType"
                                    :key="'payment-' + item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    class="my-1">
                                </v-radio>
                            </v-radio-group>
                            <v-divider></v-divider>
                            <v-radio-group v-model="filterTrainingType" @change="onFilterChange">
                                <template v-slot:label>
                                    <div>{{ $t('Тип подготовки') }}</div>
                                </template>
                                <v-radio
                                    v-for="item in trainingType"
                                    :key="'training-' + item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    class="my-1">
                                </v-radio>
                            </v-radio-group>
                            <v-divider></v-divider>
                            <v-radio-group v-model="filterEducationType" @change="onFilterChange">
                                <template v-slot:label>
                                    <div>{{ $t('Тип образования') }}</div>
                                </template>
                                <v-radio
                                    v-for="item in educationTypeList"
                                    :key="'education-type-' + item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    class="my-1">
                                </v-radio>
                            </v-radio-group>
                            <v-divider></v-divider>
                            <v-radio-group v-model="filterEducationForm" @change="onFilterChange">
                                <template v-slot:label>
                                    <div>{{ $t('Форма обучения') }}</div>
                                </template>
                                <v-radio
                                    v-for="item in educationFormList"
                                    :key="'education-form-' + item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    class="my-1">
                                </v-radio>
                            </v-radio-group>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="9">
                    <v-data-table
                        :headers="placeHeaders"
                        :items="placeList"
                        hide-default-footer
                        :item-class="itemRowBackground"
                        :footer-props="{'items-per-page-options': [-1]}"
                        class="elevation-1 place-list">
                        <template v-slot:item.actions="{ index, item }">
                            <v-btn
                                v-if="item.is_have"
                                depressed
                                x-small
                                color="warning"
                                @click.stop="edit(index, item)"
                                :loading="actionIsLoading"
                            >{{ $t('Редактировать') }}</v-btn>
                            <v-btn
                                v-else
                                depressed
                                x-small
                                color="primary"
                                @click.stop="edit(index, item)"
                                :loading="actionIsLoading"
                            >{{ $t('Настроить') }}</v-btn>
                        </template>
                    </v-data-table>
                </v-col>
                </v-row>
            </v-fade-transition>
            <v-dialog v-model="editDialog" width="600" :persistent="actionIsLoading">
                        <v-card>
                            <v-card-title class="headline lighten-2">{{ modalTitle }}</v-card-title>
                            <v-card-text>
                                <v-divider class="mb-5"></v-divider>
                                <v-form class="form" ref="editForm">
                                    <v-row>
                                        <v-col>{{ $t('Код квалификации') }}:</v-col>
                                        <v-col>{{ currentItem.qualification_code }}</v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>{{ $t('Наименование квалификации') }}:</v-col>
                                        <v-col>{{ currentItem.name }}</v-col>
                                    </v-row>
                                    <v-row v-if="currentItem.payment_type_name">
                                        <v-col>{{ $t('Форма оплаты') }}:</v-col>
                                        <v-col>{{ currentItem.payment_type_name }}</v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>{{ $t('Язык обучения') }}:</v-col>
                                        <v-col>{{ currentItem.lang_study_name }}</v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-select
                                                v-model="acsSettingsInfo.required_predmets_first"
                                                :items="certificatePredmetList"
                                                item-text="name"
                                                item-value="id"
                                                :disabled="isRequiredPredmetsDisabled"
                                                :rules="requiredPredmetFirstRules"
                                                :label="$t('Первый обязательный предмет')">
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-select
                                                v-model="acsSettingsInfo.required_predmets_second"
                                                :items="certificatePredmetList"
                                                item-text="name"
                                                item-value="id"
                                                clearable
                                                :disabled="isRequiredPredmetsDisabled"
                                                :label="$t('Второй обязательный предмет')">
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-select
                                                v-model="acsSettingsInfo.profilePredmetsFirst"
                                                :items="profilePredmetList"
                                                item-text="name"
                                                item-value="id"
                                                :rules="profilePredmetRules"
                                                :label="$t('Первый профильный предмет')">
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-select
                                                v-model="acsSettingsInfo.profilePredmetsSecond"
                                                :items="profilePredmetList"
                                                item-text="name"
                                                item-value="id"
                                                :rules="profilePredmetRules"
                                                :label="$t('Второй профильный предмет')">
                                            </v-select>
                                        </v-col>
                                    </v-row>

                                    <sign-ecp
                                        :key="'sign-ecp-acs-' + signEcpKey"
                                        @update-ecp-file-data="ecpFileData = $event"
                                        @update-ecp-password="ecpPassword = $event"
                                    />
                                </v-form>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-btn color="blue darken-1" text @click.stop="closeEditDialog">{{ $t('Отмена') }}</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click.stop="editSubmit">
                                    {{ $t('Сохранить') }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
    import {
        buildAcsProfilesParams,
        buildAcsSettingFormData,
        filterAcsSettingList,
        getAcsSettingHeaders,
        getCollegeFilterOptions,
        initializeAcsSettingFilters,
        mapAcsSettingFormValues,
        mapAcsSettingList,
        mapProfilesResponseToSubjectLists,
        needsAcsSettingPreset,
    } from '@/utils/college';
    import { getMetadataLabel } from '@/utils/metadata';

    export default {
        mounted() {
            this.getData();
        },
        computed: {
            usesCollegeNewApi() {
                return this.$store.getters.usesCollegeNewApi;
            },
            modalTitle() {
                if (this.usesCollegeNewApi && this.acsPresetMode) {
                    return this.$t('Настроить');
                }
                return this.currentItem.is_have ? this.$t('Редактировать') : this.$t('Настроить');
            },
            isRequiredPredmetsDisabled() {
                return this.usesCollegeNewApi;
            },
            requiredPredmetFirstRules() {
                if (this.isRequiredPredmetsDisabled) {
                    return [];
                }
                return [v => v !== null && v !== undefined && v !== '' || this.$t('Обязательное поле')];
            },
            profilePredmetRules() {
                return [v => v !== null && v !== undefined && v !== '' || this.$t('Обязательное поле')];
            },
        },
        data: () => ({
            isLoading: true,
            placeHeaders: [],
            placeList: [],
            allPlaceList: [],
            collegeMetadata: {},
            trainingType: [],
            paymentType: [],
            educationFormList: [],
            educationTypeList: [],
            actionIsLoading: false,
            ecpFileData: '',
            ecpPassword: '',
            signEcpKey: 0,
            filterPaymentType: null,
            filterTrainingType: null,
            filterEducationType: null,
            filterEducationForm: null,
            currentItem: {},
            editDialog: false,
            acsPresetMode: false,
            profilePredmetList: [],
            certificatePredmetList: [],
            acsSettingsInfo: {},
        }),
        methods: {
            itemRowBackground(item) {
                if (+item.acs_id && item.is_have) {
                    return 'light-green lighten-4';
                }
                return '';
            },
            onFilterChange() {
                if (this.usesCollegeNewApi) {
                    this.applyFilters();
                    return;
                }
                this.getData();
            },
            applyFilters() {
                this.placeList = filterAcsSettingList(this.allPlaceList, {
                    paymentType: this.filterPaymentType,
                    trainingType: this.filterTrainingType,
                    educationType: this.filterEducationType,
                    educationForm: this.filterEducationForm,
                });
            },
            loadFilterOptions() {
                const filterOptions = getCollegeFilterOptions(this.collegeMetadata);
                this.paymentType = filterOptions.paymentType;
                this.trainingType = filterOptions.trainingType;
                this.educationTypeList = filterOptions.educationTypeList;
                this.educationFormList = filterOptions.educationFormList;
            },
            mapCurrentItemPaymentTypeName(item) {
                if (!this.usesCollegeNewApi || !this.collegeMetadata.payment_type) {
                    return item.payment_type_name || '';
                }
                return getMetadataLabel(this.collegeMetadata.payment_type, item.payment_type);
            },
            async loadProfilesSubjectLists(formValues) {
                try {
                    const response = await this.$http.get('/profiles', {
                        params: buildAcsProfilesParams(formValues),
                        silent: true,
                    });
                    const lists = mapProfilesResponseToSubjectLists(response.data, formValues);
                    this.certificatePredmetList = lists.certificatePredmetList;
                    this.profilePredmetList = lists.profilePredmetList;
                } catch (error) {
                    this.certificatePredmetList = [];
                    this.profilePredmetList = [];
                }
            },
            async loadLegacySubjectLists() {
                if (!this.profilePredmetList.length) {
                    await this.$http.get('/profilePredmet', { silent: true }).then((response) => {
                        this.profilePredmetList = response.data.data || [];
                    }).catch(() => {});
                }

                await this.$http.get('/certificatePredmet?education_type_id=' + this.filterEducationType, { silent: true }).then((response) => {
                    this.certificatePredmetList = response.data.data || [];
                }).catch(() => {});
            },
            async edit(index, item) {
                this.actionIsLoading = true;
                this.currentItem = {
                    ...item,
                    payment_type_name: this.mapCurrentItemPaymentTypeName(item),
                };

                try {
                    if (this.usesCollegeNewApi) {
                        if (needsAcsSettingPreset(item)) {
                            const presetResponse = await this.$http.get('/acssetting-preset', {
                                params: { qualification_id: item.qualification_id },
                            });
                            if (!presetResponse.data || !presetResponse.data.status) {
                                this.$store.dispatch('alertAdd', {
                                    text: (presetResponse.data && presetResponse.data.message) || this.$t('Ошибка'),
                                    type: 'error',
                                });
                                return;
                            }
                            const presetData = (presetResponse.data && presetResponse.data.data) || presetResponse.data || {};
                            this.acsSettingsInfo = mapAcsSettingFormValues(presetData);
                            this.acsPresetMode = true;
                        } else {
                            this.acsSettingsInfo = mapAcsSettingFormValues(item);
                            this.acsPresetMode = false;
                        }

                        await this.loadProfilesSubjectLists(this.acsSettingsInfo);
                        this.editDialog = true;
                        return;
                    }

                    await this.$http.get('/acsSettingsInfo' + (
                        this.currentItem.acs_id
                            ? '?acs_id=' + this.currentItem.acs_id
                            : '?training_type_id=' + (this.filterTrainingType || 1)
                            + '&payment_type_id=' + (this.filterPaymentType || 2)
                            + '&education_type_id=' + (this.filterEducationType || 1)
                            + '&education_form_id=' + (this.filterEducationForm || 1)
                            + '&qualification_code=' + this.currentItem.qualification_code
                            + '&lang_short=' + this.currentItem.lang_short
                    )).then((response) => {
                        this.acsSettingsInfo = {
                            required_predmets_first: response.data.data.compulsory_subject_first,
                            required_predmets_second: response.data.data.compulsory_subject_second,
                            profilePredmetsFirst: response.data.data.profile_predmet_first,
                            profilePredmetsSecond: response.data.data.profile_predmet_second,
                        };
                        this.editDialog = true;
                    });

                    await this.loadLegacySubjectLists();
                } finally {
                    this.actionIsLoading = false;
                }
            },
            closeEditDialog() {
                this.currentItem = {};
                this.editDialog = false;
                this.acsSettingsInfo = {};
                this.acsPresetMode = false;
                this.certificatePredmetList = [];
                this.ecpFileData = '';
                this.ecpPassword = '';
                this.signEcpKey += 1;
            },
            hasDuplicateSubjects() {
                const {
                    required_predmets_first: firstRequired,
                    required_predmets_second: secondRequired,
                    profilePredmetsFirst: firstProfile,
                    profilePredmetsSecond: secondProfile,
                } = this.acsSettingsInfo;

                if (firstRequired != null && secondRequired != null && firstRequired === secondRequired) {
                    return true;
                }
                if (firstProfile != null && secondProfile != null && firstProfile === secondProfile) {
                    return true;
                }
                return false;
            },
            async editSubmit() {
                if (!this.$refs.editForm.validate()) {
                    return;
                }
                if (this.hasDuplicateSubjects()) {
                    this.$store.dispatch('alertAdd', {
                        text: this.$t('Выбраны одинаковые предметы'),
                        type: 'error',
                    });
                    return;
                }
                if (!this.ecpFileData) {
                    this.$store.dispatch('alertAdd', {
                        text: this.$t('Выберите ЭЦП'),
                        type: 'error',
                    });
                    return;
                }

                this.actionIsLoading = true;
                try {
                    if (this.usesCollegeNewApi) {
                        const formData = buildAcsSettingFormData({
                            id: this.currentItem.id,
                            required_predmets_first: this.acsSettingsInfo.required_predmets_first,
                            required_predmets_second: this.acsSettingsInfo.required_predmets_second,
                            profilePredmetsFirst: this.acsSettingsInfo.profilePredmetsFirst,
                            profilePredmetsSecond: this.acsSettingsInfo.profilePredmetsSecond,
                            ecp: this.ecpFileData,
                            password: this.ecpPassword,
                        });
                        const response = await this.$http.post('/add-acssetting', formData);

                        if (!response.data || !response.data.status) {
                            this.$store.dispatch('alertAdd', {
                                text: (response.data && response.data.message) || this.$t('Ошибка'),
                                type: 'error',
                            });
                            return;
                        }

                        this.$store.dispatch('alertAdd', {
                            text: (response.data && response.data.message) || 'success',
                            type: 'success',
                        });
                        this.editDialog = false;
                        await this.getData();
                        return;
                    }

                    const legacyPayload = {
                        compulsory_subject_first: this.acsSettingsInfo.required_predmets_first,
                        compulsory_subject_second: this.acsSettingsInfo.required_predmets_second,
                        profile_predmet_first: this.acsSettingsInfo.profilePredmetsFirst,
                        profile_predmet_second: this.acsSettingsInfo.profilePredmetsSecond,
                        p12: this.ecpFileData,
                        password: this.ecpPassword,
                    };
                    await this.$http.post(
                        '/acsSettings' + (this.currentItem.acs_id ? '?acs_id=' + this.currentItem.acs_id : ''),
                        legacyPayload
                    );
                    this.$store.dispatch('alertAdd', { text: 'success', type: 'success' });
                    this.editDialog = false;
                    await this.getData();
                } finally {
                    this.actionIsLoading = false;
                }
            },
            async getData() {
                const showSkeleton = !this.placeHeaders.length;
                if (showSkeleton) {
                    this.isLoading = true;
                }

                if (this.usesCollegeNewApi) {
                    try {
                        const [acsResponse, metadataResponse] = await Promise.all([
                            this.$http.get('/acssetting'),
                            this.$http.get('/metadata'),
                        ]);
                        this.collegeMetadata = (metadataResponse.data && metadataResponse.data.data) || metadataResponse.data || {};
                        this.loadFilterOptions();
                        this.placeHeaders = getAcsSettingHeaders((key) => this.$t(key));

                        if (acsResponse.data && acsResponse.data.status) {
                            this.allPlaceList = mapAcsSettingList(acsResponse.data.data);
                            const { placeList, filters } = initializeAcsSettingFilters(this.allPlaceList, {
                                paymentType: this.filterPaymentType,
                                trainingType: this.filterTrainingType,
                                educationType: this.filterEducationType,
                                educationForm: this.filterEducationForm,
                            });
                            this.filterPaymentType = filters.paymentType;
                            this.filterTrainingType = filters.trainingType;
                            this.filterEducationType = filters.educationType;
                            this.filterEducationForm = filters.educationForm;
                            this.placeList = placeList;
                        } else {
                            this.allPlaceList = [];
                            this.placeList = [];
                        }
                    } finally {
                        if (showSkeleton) {
                            this.isLoading = false;
                        }
                    }
                    return;
                }

                try {
                    if (!this.trainingType.length) {
                        this.$http.get('/trainingType').then((response) => {
                            this.trainingType = response.data.data;
                        });
                    }

                    if (!this.paymentType.length) {
                        this.$http.get('/paymentType').then((response) => {
                            this.paymentType = response.data.data;
                        });
                    }

                    if (!this.educationFormList.length) {
                        this.$http.get('/educationForm').then((response) => {
                            this.educationFormList = response.data.data;
                        });
                    }

                    if (!this.educationTypeList.length) {
                        this.$http.get('/educationType').then((response) => {
                            this.educationTypeList = response.data.data;
                        });
                    }

                    const response = await this.$http.get(
                        '/acsSettings?training_type_id=' + (this.filterTrainingType || 1)
                        + '&payment_type_id=' + (this.filterPaymentType || 2)
                        + '&education_type_id=' + (this.filterEducationType || 1)
                        + '&education_form_id=' + (this.filterEducationForm || 1)
                    );
                    this.placeHeaders = response.data.data.capacityList.headers;
                    this.placeHeaders.push({ value: 'actions', sortable: false });
                    this.placeList = response.data.data.capacityList.list;
                } finally {
                    if (showSkeleton) {
                        this.isLoading = false;
                    }
                }
            },
        },
        watch: {
            editDialog(v) {
                if (!v) {
                    if (this.$refs.editForm) {
                        this.$refs.editForm.resetValidation();
                    }
                    this.closeEditDialog();
                }
            },
        },
    };
</script>

<style type="text/css" scoped src="@/assets/css/college/PlaceListView.css"></style>
<style scoped>
.acs-skeleton-heading {
    padding: 16px 16px 0;
}
</style>
